<bt-navbar #navbar [title]="title">
  <div fxLayout="row" fxLayoutAlign="start center" signedInLeftAlign>
    <bt-age-queue-chips></bt-age-queue-chips>
    <bt-queue-chips *hasAccess="['admin', 'skybox_level_1']"></bt-queue-chips>
    <bt-insight-queue-chips [componentBreakpoint]="'gt-lg'" [showOrgSwitcher]="isInsightMod" class="insight-queue-chips"
                            *hasAccess="['insight_moderator', 'admin', 'insight_auditor']"></bt-insight-queue-chips>
  </div>

  <ng-container signedInRightAlign>
    <a *hasAccess="['homepage_preview']"
       matButton="tonal"
       routerLink="stores/home"
       [ngClass]="selectionModel.isSelected(PortalNavLocations.home) ? 'nav-button-selected' : ''"
       (click)="setSelected(PortalNavLocations.home)">Home
    </a>

    <a *hasAccess="['user', 'insight_auditor', 'external_insight_auditor', 'realogram_editor']"
       matButton="tonal"
       routerLink="stores"
       [ngClass]="selectionModel.isSelected(PortalNavLocations.stores) ? 'nav-button-selected' : ''"
       (click)="setSelected(PortalNavLocations.stores)">Stores
    </a>

    @if (this.hasUsersAccess) {
      <a matButton="tonal"
         routerLink="users"
         [ngClass]="selectionModel.isSelected(PortalNavLocations.users) ? 'nav-button-selected' : ''"
         (click)="setSelected(PortalNavLocations.users)">Users
      </a>
    }

    @if (this.hasDnaAccess) {
      <a matButton="tonal"
         routerLink="dna"
         [ngClass]="selectionModel.isSelected(PortalNavLocations.dna) ? 'nav-button-selected' : ''"
         (click)="setSelected(PortalNavLocations.dna)">Badger D<span style="font-size: x-small">&</span>A
      </a>
    }

    <a *hasAccess="['admin', 'realogram_editor']"
       matButton="tonal"
       routerLink="queued-base-scans"
       [ngClass]="selectionModel.isSelected(PortalNavLocations.basescans) ? 'nav-button-selected' : ''"
       (click)="setSelected(PortalNavLocations.basescans)">Base Scans
    </a>

    <button #searchButton mat-icon-button (click)="openSearchDialog()" title="Search...">
      <mat-icon>search</mat-icon>
    </button>
  </ng-container>

  <ng-container smallScreenItems>
    @if (authService.hasCurrentUser()) {
      <button #navMenuButton mat-icon-button #navMenuTrigger="matMenuTrigger" class="navbar-button"
              [mat-menu-trigger-for]="menu" fxHide="false"
              fxHide.gt-md>
        <mat-icon>menu</mat-icon>
      </button>
    }

    <mat-menu #menu xPosition="before" style="width: 400px !important;">
      <a *hasAccess="['user']" mat-menu-item
         routerLink="/stores/home">Home</a>
      <a *hasAccess="['user', 'insight_auditor', 'external_insight_auditor', 'realogram_editor']" mat-menu-item
         routerLink="/stores">Stores</a>
      @if (this.hasDnaAccess) {
        <a mat-menu-item routerLink="/dna">Badger D<span style="font-size: x-small">&</span>A</a>
      }
      <a *hasAccess="['admin', 'realogram_editor']" mat-menu-item
         routerLink="/queued-base-scans">Base Scans</a>
      <a mat-menu-item (click)="openSearchDialog()">Search</a>
      <a mat-menu-item routerLink="users/profile">Profile</a>
      <button mat-menu-item (click)="navbar.signOut()">Sign Out</button>
    </mat-menu>
  </ng-container>
</bt-navbar>

<main class="content-container">
  <router-outlet></router-outlet>
</main>
